<template>
  <div>
    <v-btn 
    @click="toggleAddDialog()" 
    class="info text--white" 
    slot="activator"
    >
      Add New
    </v-btn>
    <v-dialog 
    :value="addCourseTypeDialog" 
    max-width="500px" 
    persistent
    >
      <v-card>
        <v-card-title 
        class="pt-1 pb-1 headline grey lighten-2" 
        color="primary" 
        primary-title
        >
          <span class="headline">Add Course Type</span>
          <v-spacer />
          <v-btn 
          @click="toggleAddDialog()" 
          fab 
          small 
          text
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex 
              md12 
              sm12 
              xs12
              >
                <v-text-field 
                :error-messages="addNameErrors" 
                @blur="$v.addName.$touch()" 
                @input="$v.addName.$touch()"
                label="Name" 
                v-model="addName" 
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn 
          @click="saveNewItemAndCloseDialog" 
          color="green" 
          text
          >
            Save
          </v-btn>

          <v-btn 
          @click="closeNewItem" 
          color="red darken-1" 
          text
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EditTableFunctions from '@/components/editTableFunctions';
import { FETCH_COURSE_TYPE_LIST, SAVE_NEW_COURSE_TYPE } from "@/store/course_type/actions.js";
import { RESET_DEFAULT_NEW_COURSE_TYPE, TOGGLE_NEW_COURSE_TYPE_DIALOG, UPDATE_ADD_COURSE_TYPE_FIELD } from "@/store/course_type/mutations.js";
import { required, } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "AddCourseTypeDialog",
  validations: {
    addName: { required },
  },
  mixins: [
    EditTableFunctions,
  ],
  computed: {
    ...mapGetters(
      [
        "addCourseTypeDialog"
      ]
    ),
    addName: {
      get() {
        return this.$store.state.courseType.addCourseType.name;
      },
      set(value) {
        this.updateNewValue('name', value);
      },
    },
    addNameErrors() {
      const errors = [];
      if (!this.$v.addName.$dirty) return errors;
      !this.$v.addName.required && errors.push('required.');
      return errors
    },
  },

  mounted() {
    this.resetNewItemToDefault();
  },

  methods: {
    ...mapActions({
      fetchTableList: FETCH_COURSE_TYPE_LIST,
      saveNewTableItemRecord: SAVE_NEW_COURSE_TYPE,
    }),
    //
    ...mapMutations({
      toggleAddDialog: TOGGLE_NEW_COURSE_TYPE_DIALOG,
      updateTableItemToAdd: UPDATE_ADD_COURSE_TYPE_FIELD,
      resetNewItemToDefault: RESET_DEFAULT_NEW_COURSE_TYPE,
    }),
  }
}
</script>

<style scoped></style>
